import React, { useState, useEffect } from 'react';

function getToken() { return localStorage.getItem('synapse_token'); } // chave real do login (conserto 23/09/2026)

export default function Atendimentos() {
    const [dados, setDados] = useState([]);
    const [minutos, setMinutos] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(function() {
        fetch('/api/billing/atendimentos', { headers: { 'Authorization': 'Bearer ' + getToken() } })
            .then(function(r) { return r.json(); })
            .then(function(j) { setDados(Array.isArray(j) ? j : []); setLoading(false); })
            .catch(function() { setLoading(false); });
        fetch('/api/billing/minutos', { headers: { 'Authorization': 'Bearer ' + getToken() } })
            .then(function(r) { return r.json(); })
            .then(function(j) { setMinutos(Array.isArray(j) ? j : []); })
            .catch(function() {});
    }, []);
    var totalGeral = dados.reduce(function(t, d) { return t + parseInt(d.atendimentos_mes || 0); }, 0);
    var porCliente = {};
    dados.forEach(function(d) { (porCliente[d.nome] = porCliente[d.nome] || []).push(d); });
    return (
        <div style={{ padding: 24 }}>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, marginBottom: 20 }}>
                <h1 style={{ fontSize: 22, margin: 0 }}>Atendimentos</h1>
                <span style={{ color: 'var(--text-muted)', fontSize: 13 }}>mes atual · regra: novo atendimento apos 8h de silencio · canais contam separado</span>
            </div>
            {loading ? <div>Carregando...</div> : dados.length === 0 ? <div>Nenhum atendimento no mes.</div> : (
            <>
            <div className="card" style={{ marginBottom: 20, display: 'flex', gap: 30, padding: 16 }}>
                <div><div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Total no mes</div><div style={{ fontSize: 26, fontWeight: 700 }}>{totalGeral}</div></div>
                <div><div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Clientes ativos</div><div style={{ fontSize: 26, fontWeight: 700 }}>{Object.keys(porCliente).length}</div></div>
            </div>
            {Object.keys(porCliente).map(function(cliente) {
                var linhas = porCliente[cliente];
                var totCli = linhas.reduce(function(t, d) { return t + parseInt(d.atendimentos_mes || 0); }, 0);
                return (
                    <div key={cliente} className="card" style={{ marginBottom: 16, padding: 16 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                            <span style={{ fontWeight: 700 }}>{cliente}</span>
                            <span style={{ fontWeight: 700 }}>{totCli} no mes</span>
                        </div>
                        {linhas.map(function(d) {
                            return (
                                <div key={d.funcionario_id} style={{ display: 'flex', gap: 16, padding: '8px 0', borderTop: '1px solid var(--border)', fontSize: 14, flexWrap: 'wrap' }}>
                                    <span style={{ minWidth: 140, fontWeight: 600 }}>{d.agente}</span>
                                    <span>{d.atendimentos_mes} atendimentos</span>
                                    <span style={{ color: 'var(--text-muted)' }}>WhatsApp {d.canal_whatsapp} · Site {d.canal_site}</span>
                                </div>
                            );
                        })}
                    </div>
                );
            })}
            </>
            )}
            {minutos.length > 0 && (
            <div className="card" style={{ marginTop: 8, padding: 16 }}>
                <div style={{ fontWeight: 700, marginBottom: 8 }}>Telefonia — Minutos (ciclo atual)</div>
                {minutos.map(function(m) {
                    return (
                        <div key={m.cliente_id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '8px 0', borderTop: '1px solid var(--border)', flexWrap: 'wrap', fontSize: 14 }}>
                            <span style={{ minWidth: 180, fontWeight: 600 }}>{m.nome}</span>
                            <span>{m.minutos} min · {m.ligacoes} ligacoes</span>
                            <span style={{ color: 'var(--text-muted)' }}>{m.teto ? ('teto ' + m.teto + ' min (' + m.pct + '%)') : 'ilimitado'}</span>
                            {m.bloqueada && <span style={{ fontSize: 12, color: '#f66', fontWeight: 700 }}>BLOQUEADA</span>}
                            <button className="btn-ghost" style={{ marginLeft: 'auto' }} onClick={async function() {
                                try {
                                    var r = await fetch('/api/billing/minutos/' + m.cliente_id + '/extrato', { headers: { 'Authorization': 'Bearer ' + getToken() } });
                                    var ex = await r.json();
                                    var w = window.open('', '_blank');
                                    var linhas = (ex.ligacoes || []).map(function(l) {
                                        var d = new Date(l.inicio || l.criado_em);
                                        return '<tr><td>' + d.toLocaleString('pt-BR') + '</td><td>' + (l.numero_contato || '') + '</td><td>' + (l.direcao || '') + '</td><td style="text-align:right">' + (l.duracao_segundos || 0) + 's</td><td style="text-align:right">' + l.minutos + '</td></tr>';
                                    }).join('');
                                    w.document.write('<html><head><title>Extrato de Telefonia - ' + ex.cliente + '</title><style>body{font-family:Arial,sans-serif;margin:40px;color:#222}h1{font-size:20px;margin:0}h2{font-size:15px;font-weight:normal;color:#555;margin:4px 0 20px}table{width:100%;border-collapse:collapse;font-size:13px}th,td{border-bottom:1px solid #ddd;padding:6px 8px;text-align:left}th{background:#f5f5f5}.tot{margin-top:16px;font-size:14px;font-weight:bold}.marca{display:flex;justify-content:space-between;align-items:center;border-bottom:2px solid #222;padding-bottom:10px;margin-bottom:20px}</style></head><body><div class="marca"><h1>NEUROTECH-X</h1><span>Extrato de Telefonia</span></div><h2>Cliente: ' + ex.cliente + ' — Ciclo desde ' + new Date(ex.ciclo_inicio).toLocaleDateString('pt-BR') + (ex.teto ? (' — Teto: ' + ex.teto + ' min') : ' — Ilimitado') + '</h2><table><tr><th>Data/Hora</th><th>Numero</th><th>Direcao</th><th>Duracao</th><th>Min. tarifados</th></tr>' + linhas + '</table><div class="tot">Total: ' + ex.total_minutos + ' minutos em ' + ex.total_ligacoes + ' ligacoes</div><script>window.print()</scr' + 'ipt></body></html>');
                                    w.document.close();
                                } catch (e) { alert('Erro ao abrir extrato'); }
                            }}>Extrato</button>
                        </div>
                    );
                })}
            </div>
            )}
        </div>
    );
}
